import React, { useState } from "react";
import {
  Stack,
  Paper,
  Text,
  SimpleGrid,
  Group,
  ThemeIcon,
  Box,
  Title,
} from "@mantine/core";
import { IconHandClick, IconFileSpreadsheet } from "@tabler/icons-react";
import { BulkUploadTab, ShopSingleProductForm } from "../ProductForm";

export default function CatalogStep({ applicationId }) {
  const [method, setMethod] = useState("manual");

  return (
    <Stack gap="xl">
      <Box>
        <Title order={3} size="h2" mb="xs">
          How do you want to add products?
        </Title>
        <Text size="lg" c="dimmed">
          You can add items one-by-one by typing them in, or upload a
          spreadsheet if you have a massive menu.
        </Text>
      </Box>

      {/* Massive Card-Based Selectors */}
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        {/* Option 1: Manual Entry Card */}
        <Paper
          withBorder
          p="xl"
          radius="md"
          onClick={() => setMethod("manual")}
          style={{
            cursor: "pointer",
            transition: "all 0.2s ease",
            borderColor:
              method === "manual"
                ? "var(--mantine-color-blue-6)"
                : "var(--mantine-color-gray-3)",
            backgroundColor:
              method === "manual" ? "var(--mantine-color-blue-0)" : "white",
          }}
          className="hover:shadow-md"
        >
          <Group gap="md" align="center" wrap="nowrap">
            <ThemeIcon
              size={56}
              radius="md"
              color={method === "manual" ? "blue" : "gray"}
              variant={method === "manual" ? "filled" : "light"}
            >
              <IconHandClick size={28} />
            </ThemeIcon>
            <Box>
              <Text
                size="lg"
                fw={700}
                c={method === "manual" ? "blue.9" : "dark.9"}
              >
                Add Manually
              </Text>
              <Text size="sm" c="dimmed" mt={4}>
                Type in the details for one product at a time.
              </Text>
            </Box>
          </Group>
        </Paper>

        {/* Option 2: Bulk CSV Upload Card */}
        <Paper
          withBorder
          p="xl"
          radius="md"
          onClick={() => setMethod("bulk")}
          style={{
            cursor: "pointer",
            transition: "all 0.2s ease",
            borderColor:
              method === "bulk"
                ? "var(--mantine-color-blue-6)"
                : "var(--mantine-color-gray-3)",
            backgroundColor:
              method === "bulk" ? "var(--mantine-color-blue-0)" : "white",
          }}
          className="hover:shadow-md"
        >
          <Group gap="md" align="center" wrap="nowrap">
            <ThemeIcon
              size={56}
              radius="md"
              color={method === "bulk" ? "blue" : "gray"}
              variant={method === "bulk" ? "filled" : "light"}
            >
              <IconFileSpreadsheet size={28} />
            </ThemeIcon>
            <Box>
              <Text
                size="lg"
                fw={700}
                c={method === "bulk" ? "blue.9" : "dark.9"}
              >
                Upload CSV File
              </Text>
              <Text size="sm" c="dimmed" mt={4}>
                Best if you have more than 10 products ready.
              </Text>
            </Box>
          </Group>
        </Paper>
      </SimpleGrid>

      {/* Render the selected form in a clean container */}
      <Paper
        withBorder
        p="xl"
        radius="md"
        bg="gray.0"
        style={{ borderColor: "var(--mantine-color-gray-3)" }}
      >
        {method === "manual" ? (
          <ShopSingleProductForm
            mode="create"
            stallApplicationId={applicationId}
            setupType="EVENT"
          />
        ) : (
          <BulkUploadTab
            shopId={null}
            stallApplicationId={applicationId}
            onSuccess={() =>
              alert(
                "Products processed successfully! You can upload more or proceed.",
              )
            }
          />
        )}
      </Paper>
    </Stack>
  );
}
